import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { User } from "../models/auth.models";
import { StorageService } from "./storage.service";

const USER_KEY = "currentUser";

@Injectable({ providedIn: "root" })
export class AuthService {
  private currentUserSubject: BehaviorSubject<User | null>;
  public currentUser: Observable<User | null>;

  constructor(private storage: StorageService) {
    this.currentUserSubject = new BehaviorSubject<User | null>(
      this.storage.get<User>(USER_KEY),
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User | null {
    return this.currentUserSubject.value;
  }

  public getUser(): User | null {
    return this.storage.get<User>(USER_KEY);
  }

  login(user: any): any {
    const content = { ...user };
    content.token = user.jwtToken?.token;

    if (content && content.token) {
      this.storage.set(USER_KEY, content);
      this.currentUserSubject.next(content);
    }
    return content;
  }

  updateUserLanguage(user: User): void {
    const currentUser = this.getUser();
    if (!currentUser) return;
    currentUser.language = user.language;

    this.storage.set(USER_KEY, currentUser);
    this.currentUserSubject.next(currentUser);
  }

  updateUserContractor(contractorId: number, contractorName: string): void {
    const currentUser = this.getUser();
    if (!currentUser) return;
    currentUser.contractorId = contractorId;
    currentUser.contractorName = contractorName;

    this.storage.set(USER_KEY, currentUser);
    this.currentUserSubject.next(currentUser);
  }

  logout(): void {
    this.storage.remove(USER_KEY);
    this.currentUserSubject.next(null);
  }
}
